<template>
  <div>
    <h1 class="mb-8 font-roboto text-[32px] font-medium leading-6">Партнеры</h1>
    <ClientOnly>
      <div class="relative">
        <Swiper
          v-bind="options"
          class="swiper-prtnrs-top mb-8"
          @swiper="onSwiper"
        >
          <SwiperSlide
            v-for="partner in partners[0]"
            :key="partner"
            class="swiper-slide"
          >
            <TeacherThePartnersBannerItem
              :logo="partner"
              class="h-[103px] p-2 xl:h-[91px] xl:max-h-[91px]"
            />
          </SwiperSlide>
        </Swiper>
        <Swiper v-if="!isNotDesktop" v-bind="options" @swiper="onSwiper">
          <SwiperSlide
            v-for="partner in partners[1]"
            :key="partner"
            class="swiper-slide"
          >
            <TeacherThePartnersBannerItem
              :logo="partner"
              class="h-[91px] max-h-[91px] p-2"
            />
          </SwiperSlide>
        </Swiper>
      </div>
    </ClientOnly>
  </div>
</template>

<script setup>
import 'swiper/css/mousewheel';
import 'swiper/css/pagination';

import { Mousewheel, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';

import { prtnrs } from '~/assets/data/partners';
const { onSwiper } = useSwiper();

const { isNotDesktop, isMobile } = useBreakpoint();

const options = computed(() => {
  return {
    slidesPerView: isMobile.value ? 2 : isNotDesktop.value ? 4 : 6,
    spaceBetween: 8,
    loop: true,
    pagination: isNotDesktop.value
      ? {
          clickable: true,
        }
      : false,
    mousewheel: true,
    modules: [Mousewheel, Pagination],
    grabCursor: true,
  };
});

const partners = computed(() => {
  return isNotDesktop.value
    ? [prtnrs]
    : [prtnrs.slice(0, 10), prtnrs.slice(10)];
});
</script>

<style scoped lang="scss">
.swiper-prtnrs-top {
  padding-bottom: 26px;
  --swiper-pagination-bottom: 0px;
  --swiper-pagination-bullet-height: 10px;
  --swiper-pagination-bullet-width: 10px;
  --swiper-pagination-bullet-inactive-color: #d9d9d9;
  --swiper-pagination-color: #a10009;
}
</style>
